/* Cells to and from tab-separated text: what a copied range becomes on the clipboard, and
   what a paste from a sheet (Excel, Google Sheets, another table) becomes. Pure. */

/** The range's text: a tab between cells, a line per row; tabs and line breaks inside a
    value become spaces so the shape survives the trip. */
export function toTsv(cells: string[][]): string {
  return cells.map((row) => row.map((cell) => cell.replace(/[\t\n]/g, " ")).join("\t")).join("\n");
}

/** A paste as rows of cells; the trailing line break a sheet adds is not a row. */
export function fromTsv(text: string): string[][] {
  const trimmed = text.replace(/\r/g, "").replace(/\n$/, "");
  if (!trimmed) return [];
  return trimmed.split("\n").map((line) => line.split("\t"));
}

/** Where a paste lands: one value fills a selected range; a block fills from its top-left. */
export function pastePlan(
  pasted: string[][],
  range: { r1: number; c1: number; r2: number; c2: number },
): { r: number; c: number; value: string }[] {
  if (pasted.length === 1 && pasted[0].length === 1) {
    const cells = [];
    for (let r = range.r1; r <= range.r2; r += 1) {
      for (let c = range.c1; c <= range.c2; c += 1) cells.push({ r, c, value: pasted[0][0] });
    }
    return cells;
  }
  return pasted.flatMap((row, dr) => row.map((value, dc) => ({ r: range.r1 + dr, c: range.c1 + dc, value })));
}
